export function ColorPlaceHolder(props: any) {
    return <div className='color-placeholder' style={{
        backgroundColor: `${props.color}`
    }} onClick={props.onClick} ></div>
}